<template>
  <router-link to='/'>
    <h1>Esa-Pekka Salonen</h1>
  </router-link>
</template>

<style scoped>
  h1 {
    font-size: var(--main-heading-size);
    font-family: var(--serif);
    margin: 0;
    line-height: 0.75;
    letter-spacing: -0.015em;
    white-space: preserve nowrap;
    text-transform: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
